import { UseQueryResult, useQuery } from 'react-query';
import { BillingPlanRetrieve } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalBillingPlanProps {
  gym?: string;
  packageId?: string;
  billingPlanId?: string;
}

export default function useSalesPortalBillingPlan({
  gym,
  packageId,
  billingPlanId,
}: IUseSalesPortalBillingPlanProps): UseQueryResult<{ data: BillingPlanRetrieve }> {
  return useQuery(
    ['salesPortalBillingPlans', gym, packageId, billingPlanId],
    () => client.get(`sales-portal/gyms/${gym}/packages/${packageId}/billing-plans/${billingPlanId}/`),
    {
      enabled: !!gym && !!packageId && !!billingPlanId,
      // Changing the billing plan inside the checkout swaps the route param in
      // place; serving the previous plan while the new one loads keeps the
      // checkout mounted (otherwise completed-step state would reset).
      keepPreviousData: true,
    },
  );
}
